var brandenburgQuestions = [{
    "id": "301",
    "question": "Welches Wappen gehört zum Bundesland Brandenburg?",
	  "image": "331",
    "answers": [
  		{
  			content: "1",
  			key: 1
  		},
  		{
  			content: "2",
  			key: 0
  		},
  		{
  			content: "3",
  			key: 0
  		},
  		{
  			content: "4",
  			key: 0
  		}
  	],
  	"category": "Brandenburg",
	},
  {
    "id": "302",
    "question": "Welches ist ein Landkreis in Brandenburg?",
    "answers": [
		{
			content: "Prignitz",
			key: 1
		},
		{
			content: "Rhein-Sieg-Kreis",
			key: 0
		},
		{
			content: "Vogtlandkreis",
			key: 0
		},
		{
			content: "Amberg-Sulzbach",
			key: 0
		}
  	],
  	 "category": "Brandenburg",
  },
    {
      "id": "303",
      "question": "Für wie viele Jahre wird der Landtag in Brandenburg gewählt?",
      "answers": [
      {
        content: "3",
        key: 0
      },
      {
        content: "4",
        key: 0
      },
      {
        content: "5",
        key: 1
      },
      {
        content: "6",
        key: 0
      }
      ],
      "category": "Brandenburg",
    },
    {
      "id": "304",
      "question": "Ab welchem Alter darf man in Brandenburg bei Kommunalwahlen wählen?",
      "answers": [
      {
        content: "14",
        key: 0
      },
      {
        content: "16",
        key: 1
      },
      {
        content: "18",
        key: 0
      },
      {
        content: "20",
        key: 0
      }
      ],
      "category": "Brandenburg",
    },
    {
      "id": "305",
      "question": "Welche Farben hat die Landesflagge von Brandenburg?",
      "answers": [
      {
        content: "blau-weiß-rot",
        key: 0
      },
      {
        content: "rot-weiß",
        key: 1
      },
      {
        content: "grün-weiß-rot",
        key: 0
      },
      {
        content: "schwarz-gelb",
        key: 0
      }
      ],
      "category": "Brandenburg",
    },
    {
      "id": "306",
      "question": "Wo können Sie sich in Brandenburg über politische Themen informieren?",
      "answers": [
      {
        content: "bei den Kirchen",
        key: 0
      },
      {
        content: "beim Ordnungsamt der Gemeinde",
        key: 0
      },
      {
        content: "bei der Landeszentrale für politische Bildung",
        key: 1
      },
      {
        content: "bei der Verbraucherzentrale",
        key: 0
      }
      ],
      "category": "Brandenburg",
    },
    {
      "id": "307",
      "question": "Die Landeshauptstadt von Brandenburg heißt...",
      "answers": [
      {
        content: "Potsdam.",
        key: 1
      },
      {
        content: "Cottbus.",
        key: 0
      },
      {
        content: "Brandenburg.",
        key: 0
      },
      {
        content: "Frankfurt/Oder.",
        key: 0
      }
      ],
      "category": "Brandenburg",
    },
    {
      "id": "308",
      "question": "Welches Bundesland ist Brandenburg?",
      "image": "338",
      "answers": [
      {
        content: "1",
        key: 0
      },
      {
        content: "2",
        key: 0
      },
      {
        content: "3",
        key: 0
      },
      {
        content: "4",
        key: 1
      }
      ],
      "category": "Brandenburg",
    },
    {
      "id": "309",
      "question": "Wie nennt man den Regierungschef / die Regierungschefin in Brandenburg?",
      "answers": [
      {
        content: "Erster Minister / Erste Ministerin",
        key: 0
      },
      {
        content: "Premierminister / Premierministerin",
        key: 0
      },
      {
        content: "Bürgermeister / Bürgermeisterin",
        key: 0
      },
      {
        content: "Ministerpräsident / Ministerpräsidentin",
        key: 1
      }
      ],
      "category": "Brandenburg",
    },
    {
      "id": "310",
      "question": "Welchen Minister / welche Ministerin hat Brandenburg nicht?",
      "answers": [
      {
        content: "Justizminister / Justizministerin",
        key: 0
      },
      {
        content: "Außenminister / Außenministerin",
        key: 1
      },
      {
        content: "Finanzminister / Finanzministerin",
        key: 0
      },
      {
        content: "Innenminister / Innenministerin",
        key: 0
      }
      ],
      "category": "Brandenburg",
    },
]

export default brandenburgQuestions;
